import React from 'react'
import { device, INTERNATIONAL_STREAM, OCR_STREAM } from '../../utils/constants'
import styled from '@emotion/styled'
import { sessionAtom } from '../../state/session'
import { useRecoilValue } from 'recoil'

// map cu ocr si CI
const OCR_USEFUL_LINKS = [
	{
		label: 'About',
		redirectTo: 'https://www.ocr.org.uk/about/'
	},
	{
		label: 'Contact us',
		redirectTo: 'https://www.ocr.org.uk/contact-us/'
	}
]

const INTERNATIONAL_USEFUL_LINKS = [
	{
		label: 'About',
		redirectTo: 'https://www.cambridge.org/what-we-do'
	},
	{
		label: 'Contact us',
		redirectTo: 'https://help.cambridgeinternational.org/hc/en-gb/requests/new?ticket_form_id=53542'
	}
]

const USEFUL_LINKS_MAP = new Map([
	[OCR_STREAM, OCR_USEFUL_LINKS],
	[INTERNATIONAL_STREAM, INTERNATIONAL_USEFUL_LINKS]
])

const UsefulLinksElem = styled.div`
	@media ${device.mobile} {
		display: flex;
		flex-direction: row;
		a:first-of-type {
			margin-left: 0;
		}
	}
`

const UsefulLinks = () => {
	const userSession = useRecoilValue(sessionAtom)
	const usefulLinks = USEFUL_LINKS_MAP.get(userSession?.selectedBusinessStream || '') || OCR_USEFUL_LINKS

	return (
		<UsefulLinksElem data-testid="website-useful-links">
			{usefulLinks.map((item, index) => (
				<a
					href={item.redirectTo}
					target="_blank"
					rel="noreferrer"
					key={item.label}
					data-testid={`${item.label}-test-id`}
					className="text-14 text-semiBold ml-24"
				>
					{item.label}
				</a>
			))}
		</UsefulLinksElem>
	)
}

export default UsefulLinks
